const TOKEN_KEY = 'access_token';
const LANG_KEY = 'lang';
const KYC_KEY = 'kyc_status';

/**
 * Manage the how Access Tokens are being stored and received from localStorage.
 *
 * Current implementation stores to localStorage. localStorage should always be
 * accessed through this instance.
 * */
const TokenService = {
    getToken() {
        return localStorage.getItem(TOKEN_KEY);
    },

    setToken(accessToken: string) {
        localStorage.setItem(TOKEN_KEY, accessToken);
    },
    getKycName() {
        return localStorage.getItem(KYC_KEY);
    },

    setKycName(kycName: string) {
        localStorage.setItem(KYC_KEY, kycName);
    },
    removeKKycName() {
        localStorage.removeItem(KYC_KEY);
    },

    removeToken() {
        localStorage.removeItem(TOKEN_KEY);
    },

    getLang() {
        return localStorage.getItem(LANG_KEY);
    },

    setLang(lang: string) {
        localStorage.setItem(LANG_KEY, lang);
    },
    getHeader() {
        return {
            Authorization: `Bearer ${this.getToken()}`,
            'X-LANG': this.getLang() || 'vi',
            'Cache-Control': 'no-cache, no-store, must-revalidate',
            'Pragma': 'no-cache',
            'Expires': '0'
        };
    },
};

export default TokenService;
